// Silhouette stilizzata della Sicilia — pathing semplificato ma riconoscibile
export function SiciliaOutline({ className = "", fill = "currentColor", stroke = "none" }) {
  return (
    <svg
      viewBox="0 0 400 260"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
    >
      <path
        fill={fill}
        stroke={stroke}
        strokeWidth="1"
        d="M18,138 L46,122 L78,118 L110,96 L142,78 L170,66 L198,52 L220,42 L240,36 L262,32 L282,34 L298,42 L314,52 L328,66 L340,82 L352,100 L364,118 L372,138 L376,158 L372,174 L360,186 L344,194 L324,200 L302,206 L278,212 L252,218 L226,222 L200,224 L172,222 L144,218 L116,210 L92,200 L72,186 L54,170 L38,154 L22,146 Z"
      />
    </svg>
  );
}

// Pattern maiolica siciliana semplificato — tile ripetibile
export function MajolicaDivider({ className = "" }) {
  return (
    <div
      className={className}
      aria-hidden="true"
      style={{
        height: "28px",
        backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='56' height='28' viewBox='0 0 56 28'><g fill='none' stroke='%231C5D7C' stroke-width='1.2' opacity='0.4'><path d='M0 14 L14 0 L28 14 L14 28 Z'/><path d='M28 14 L42 0 L56 14 L42 28 Z'/><circle cx='14' cy='14' r='3' fill='%231C5D7C' opacity='0.6'/><circle cx='42' cy='14' r='3' fill='%231C5D7C' opacity='0.6'/></g></svg>")`,
        backgroundRepeat: "repeat-x",
        backgroundPosition: "center",
      }}
    />
  );
}

// Divisore ad arco mediterraneo (SVG wave in cima a una sezione)
export function WaveTop({ color = "#F4F7F9", className = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1440 60"
      preserveAspectRatio="none"
      className={`block w-full h-[40px] sm:h-[60px] ${className}`}
      aria-hidden="true"
    >
      <path
        fill={color}
        d="M0,30 C240,60 480,0 720,20 C960,40 1200,10 1440,30 L1440,60 L0,60 Z"
      />
    </svg>
  );
}

// Trinacria watermark (riferimento stilizzato alla gamba+testa)
export function TrinacriaWatermark({ className = "" }) {
  return (
    <svg
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <g fill="none" stroke="currentColor" strokeWidth="1.5" opacity="0.6">
        <circle cx="100" cy="100" r="22" />
        {[0, 120, 240].map((rot) => (
          <g key={rot} transform={`rotate(${rot} 100 100)`}>
            <path
              d="M100 78 L100 44 L112 32 L108 20 L96 24 L92 36 L100 44"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        ))}
      </g>
    </svg>
  );
}

// Pin per mappa
export function MapPin({ className = "" }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
      <path d="M12 2C8 2 5 5 5 9c0 5 7 13 7 13s7-8 7-13c0-4-3-7-7-7zm0 10a3 3 0 110-6 3 3 0 010 6z" />
    </svg>
  );
}
